import { MessageType } from "src/ipc/types/message/message";
import { IReportScrapingActionRequestMessage } from "src/ipc/types/message/variants/ReportScrapingMessage/variants/ReportScrapingActionRequestMessage";
import { IRcvReportScrapingInputRequestMessage } from "src/ipc/types/message/variants/ReportScrapingMessage/variants/ReportScrapingInputRequestMessage/rcv/RcvReportScrapingInputRequestMessage";
import { IReportScrapingProgressMessage } from "src/ipc/types/message/variants/ReportScrapingMessage/variants/ReportScrapingProgressMessage";
import { messageApp } from "src/ipc/utils/messageApp";
import { ScraperInput } from "src/scrapers/types/ScraperInput/ScraperInput";

export interface IProgressReporter {
    nextStep(message: string, workUnits: number): void;
    reportProgress(message: string, percentage: number): void;
    requestAction(message: string, percentage?: number): void;
    requestInput(inputs: ScraperInput[], message?: string): Promise<string[]>;
}

export class ProgressReporter implements IProgressReporter{
    private _currentStep = 0;
    private _workReporter: WorkReporter | undefined;
    constructor(private _totalSteps:number) {}
    nextStep(message:string, workUnits:number, initWorkUnits?:number) {
      this._currentStep += 1;
      this._workReporter = new WorkReporter(
        workUnits,
        (percentage, callbackMsg) => {
          const msg:IReportScrapingProgressMessage = {
            type: MessageType.REPORT_SCRAPING_PROGRESS,
            payload: {
              message: callbackMsg != null ? callbackMsg : message,
              percentage,
              totalSteps: this._totalSteps,
              currentStep: this._currentStep
            }
          };
          process.send?.(msg)
        },
        initWorkUnits
      );
    }
    reportProgress(message?:string) {
        this._workReporter?.reportProgress(message);
    }
    requestAction(message: string) {
      const msg: IReportScrapingActionRequestMessage = {
        type: MessageType.REPORT_SCRAPING_ACTION_REQUEST,
        payload: {
            message
        }
      }
      process.send?.(msg);
    }
    requestInput(inputs: ScraperInput[], message?: string): Promise<string[]> {
        const initMsg: IRcvReportScrapingInputRequestMessage = {
                type: MessageType.RCV_REPORT_SCRAPING_INPUT_REQUEST,
                payload: {
                    inputs,
                    message
                }
            }
        
        return messageApp(
            (message, resolve, reject) => {
                if(message.type === MessageType.SEND_REPORT_SCRAPING_INPUT_REQUEST){
                    resolve(message.payload.values);
                }else{
                    reject(new Error('Unexpected message type'));
                }
            },
            initMsg
        )
    }
  };


class WorkReporter {
    private _currentPercentage = 0;
    private _currentWork = 0;

    constructor(private _totalWork: number, private _callback: (percentage:number, message?: string)=>void, initWorkUnits?: number) {
      this._currentPercentage = 0;
      this._currentWork = initWorkUnits != null ? initWorkUnits : 0;
      this._callback(Math.min(100, Math.floor(this._currentWork / this._totalWork * 100)));
    }
    reportProgress(message?:string) {
      this._currentWork += 1;
      const newPercentage = Math.min(100, Math.floor(this._currentWork / this._totalWork * 100));
      if (newPercentage > this._currentPercentage) {
        this._currentPercentage = newPercentage;
        this._callback(newPercentage, message);
      }
    }
  };